import Vue from 'vue';
import App from './App.vue';

//import 'vuetify/dist/vuetify.min.css'; // Ensure you are using css-loader
import Vuelidate from 'vuelidate';
import Toasted from 'vue-toasted';
import VueClipboards from 'vue-clipboards'

import router from './router';
import {store} from './store';
import AsyncComputed from 'vue-async-computed';
import VueGoodTablePlugin from 'vue-good-table';

// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import './registerServiceWorker';
import 'aos/dist/aos.css'

import AOS from 'aos'
//import EmbarkJS from '../embarkArtifacts/embarkjs';
import VuePageTransition from 'vue-page-transition';
import Gravatar from 'vue-gravatar';
import axios from 'axios';
import Loading from 'vue-loading-overlay';

import 'vue-loading-overlay/dist/vue-loading.css';
import VueCookies from 'vue-cookies'
import vueGoodTableCjs from 'vue-good-table';
Vue.use(VueCookies);
Vue.use (VuePageTransition);
Vue.use (Vuelidate);
Vue.use (axios);
Vue.use (Toasted);
Vue.use (AsyncComputed);
Vue.use(VueClipboards)
Vue.use(VueGoodTablePlugin)
Vue.component ('loading', Loading);

Vue.component ('v-gravatar', Gravatar);
Vue.config.productionTip = false;
Vue.config.devtools = false;
Vue.config.silent = true;



//Vue.prototype.$web3=web3;

let options1 = {
  type: 'success',
  icon: 'fa-check',
  position: 'top-center',
  iconPack: 'fontawesome',

  fitToScreen: true,
  duration: 4000,
};

let options2 = {
  type: 'error',
  icon: 'fa-times',
  position: 'top-center',
  iconPack: 'fontawesome',
  fitToScreen: true,
  duration: 6000,
 
};

// register the toast with the custom message
Vue.toasted.register (
  'my_app_success',
  payload => {
    // if there is no message passed show default message
    if (!payload.message) {
      return 'Oops.. Something Went Wrong..';
    }

    // if there is a message show it with the message
    return payload.message;
  },
  options1
);
Vue.toasted.register (
  'my_app_error',
  payload => {
    // if there is no message passed show default message
    if (!payload.message) {
      return 'Oops.. Something Went Wrong..';
    }

    // if there is a message show it with the message
    return payload.message;
  },
  options2
);


new Vue ({
  //EmbarkJS,
  created() {
    AOS.init()
  },
  router,
 
  store,
  render: h => h (App),
}).$mount ('#app');
